import * as ActionTypes from '../ActionTypes';

const InitialState = {
    isLoading: false,
    my_attendance_regularization: [],
    approver_emp_regularization_mapping: []
}

export const MyAttendanceRegularizationReducer = function (state = InitialState, action) {
    switch (action.type) {
        case ActionTypes.GET_MY_ATTENDANCE_REGULARIZATION_REQUEST:
            return {
                ...state,
                isLoading: true,
                my_attendance_regularization: []
            };
        case ActionTypes.GET_APPROVER_EMP_REGULARIZATION_MAPPING_REQUEST:
            return {
                ...state,
                isLoading: true,
                approver_emp_regularization_mapping: []
            };
        case ActionTypes.UPSERT_MY_ATTENDANCE_REGULARIZATION_REQUEST:
        case ActionTypes.DELETE_MY_ATTENDANCE_REGULARIZATION_REQUEST:
        case ActionTypes.UPDATE_APPROVER_EMP_REGULARIZATION_MAPPING_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case ActionTypes.GET_MY_ATTENDANCE_REGULARIZATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                my_attendance_regularization: action.payload?.data?.data
            };
        case ActionTypes.GET_APPROVER_EMP_REGULARIZATION_MAPPING_SUCCESS:
        case ActionTypes.UPDATE_APPROVER_EMP_REGULARIZATION_MAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                approver_emp_regularization_mapping: action.payload?.data?.data
            };
        case ActionTypes.UPSERT_MY_ATTENDANCE_REGULARIZATION_SUCCESS:
        case ActionTypes.DELETE_MY_ATTENDANCE_REGULARIZATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                my_attendance_regularization: action.payload?.data?.data
            };
        case ActionTypes.GET_MY_ATTENDANCE_REGULARIZATION_ERROR:
        case ActionTypes.UPSERT_MY_ATTENDANCE_REGULARIZATION_ERROR:
        case ActionTypes.DELETE_MY_ATTENDANCE_REGULARIZATION_ERROR:
        case ActionTypes.GET_APPROVER_EMP_REGULARIZATION_MAPPING_ERROR:
        case ActionTypes.UPDATE_APPROVER_EMP_REGULARIZATION_MAPPING_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
}